import { PureComponent } from "react";

import { HoSubAck } from "types/enum";

interface IHoSubAckDisplayProps {
    status: HoSubAck;

    overrideText: string;

    /**
     * Is the appointment past due? This will change "PENDING" status to "NEVER ACCEPTED"
     * @default false
     */
    pastDue: boolean;

    /**
     * Function that renders a React.ReactNode with provided status text and override text
     *
     * @default (statusText, overrideText) => <>{statusText + overrideText}</>
     * @param statusText Status as descriptive text
     * @param overrideText Text to indicate an override
     */
    render: (statusText: string, overrideText: string) => React.ReactNode;
}

export class HoSubAckDisplay extends PureComponent<IHoSubAckDisplayProps> {
    static defaultProps = {
        overrideText: "(ov)",
        pastDue: false,
        render: (description: string, overrideText: string) => <>{description + overrideText}</>,
    };

    render() {
        let description = "";
        let overrideText: string = "";

        switch (this.props.status) {
            case HoSubAck.Approved:
                description = "Accepted";
                break;
            case HoSubAck.BuilderApproved:
                description = "Accepted";
                overrideText = this.props.overrideText;
                break;
            case HoSubAck.InternallyAccepted:
                description = "Internally Accepted";
                break;
            case HoSubAck.Pending:
                if (this.props.pastDue) {
                    description = "Never Accepted";
                } else {
                    description = "Pending";
                }
                break;
            case HoSubAck.Reschedule:
                description = "Reschedule Requested";
                break;
            default:
                break;
        }

        return this.props.render(description, overrideText);
    }
}
